import {
  Box, Button, Divider,
  Stack, Typography, useTheme
} from '@mui/material';

import RedotpayCard from "@/components/RedotpayCard";
import RpIcon from "@/components/RpIcon";
import RouteConstant from "@/constant/RouteConstant";
import { createSearchParams, useNavigate } from "react-router-dom";
import { CARD_TYPE } from "@/constant/Constant.ts";
import { useBoolean, useRequest, useSize } from "ahooks";
import { getCardDetail } from "@/services";
import { getUrlParams } from "@/utils/utils";
import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import classes from "./index.module.css";
import SimpleHeader from "@/pages/components/Headers/SimpleHeader.tsx";
import { deleteCard } from "@/services";
import { LoadingButton } from "@mui/lab";

import { getCardReissueFee, getCardReissueTypes, cardReissueApply, cardReissuePreview } from '@/services/card'
import { useSelector } from "react-redux";
import { dispatch } from "@/redux/store";
import { getCardAvailable, getCardList, getShippingAddress } from "@/redux/slices/card";
import { enqueueSnackbar } from "notistack";
import VarietySelectModal from "@/pages/components/VarietySelectModal";
import AppModal from "@/components/AppModal.tsx";
import { getUserInfo } from "@/redux/slices/user";

const ReissueCard = () => {
  const cardId = getUrlParams("cardId");
  const theme = useTheme()
  const navigate = useNavigate();
  const { t } = useTranslation()
  const size = useSize(document.querySelector('body'));
  const { shippingAddress } = useSelector((state) => state.card);
  const { user, isAuthenticated, homeInfo } = useSelector((state) => state.user);
  useEffect(() => {
    dispatch(getShippingAddress());
  }, []);

  const getCardDetailReq = useRequest(async () => {
    const res = await getCardDetail(cardId)
    return res as any
  }, { manual: true })

  useEffect(() => {
    // if () {
    getCardDetailReq.runAsync()
    // }
  }, []);

  const getCardReissueTypesReq = useRequest(async () => {

    const res = await getCardReissueTypes({
      cardType: getCardDetailReq?.data.cardType,
      cardId: cardId
    }
    )
    return res
  }, {
    manual: true,
  })

  useEffect(() => {
    if (getCardDetailReq?.data) {
      getCardReissueTypesReq.runAsync()
    }
  }, [getCardDetailReq?.data]);

  const getCardReissueFeesReq = useRequest(async () => {
    const res = await getCardReissueFee()
    return res
  }, {
    manual: false,
  })

  const reissuePreviewReq = useRequest(async () => {
    const reissuePreviewRes = await cardReissuePreview({
      cardId: cardId,
      cardShippingAddressSn: shippingAddress?.sn,
      reissueType: reissueInfo.id
    })
    return reissuePreviewRes
  }, { manual: true })

  const applyReissueReq = useRequest(async () => {
    const res = await cardReissueApply({
      cardId: cardId,
      cardShippingAddressSn: shippingAddress?.sn,
      reissueType: reissueInfo.id
    })
    return res
  }, { manual: true })

  const reissueInfo = useMemo(() => {
    if (!getCardReissueTypesReq?.data) {
      return -1
    }
    const ret = getCardReissueTypesReq?.data.find(_ => _.cardType == getCardDetailReq?.data.cardType)
    console.log("打印reissueInfo",ret)
    return ret
  }, [getCardReissueTypesReq?.data, getCardDetailReq?.data])


  const cardScale = useMemo(() => {
    const scale = size?.width / 375
    return scale
  }, [size])
  const styles = {
    padding: '0 16px'
  }

  const onVarietySelected = (variety) => {
    setSelectedVariety(variety)
    navigate(`${RouteConstant.USER_DEPOSIT}?variety_code=${variety.varietyCode}`)
  }

  const [varietySelectModalOpen, varietySelectModalOpenOperate] = useBoolean(false);
  const [selectedVariety, setSelectedVariety] = useState(null);
  const [reissssuePreviewInfoModalOpen, reisssuePreviewModalOpenOperate] = useBoolean(false);
  const [previewModalOpen, previewModalOpenOperate] = useBoolean(false);
  return (
    <>
      <Stack
        sx={{
          width: '100%',
          height: '100%',
          position: 'relative'
        }}
      >
        <SimpleHeader title={t('update_cvv')}
          action={<Box onClick={() => {
            navigate(`${RouteConstant.CARD_APPLY_LIST}`);
          }}>
            <RpIcon icon={'file'} size={22} />
          </Box>}
        />
        <Box
          sx={{
            ...styles
          }}
        >
          <Typography
            sx={{
              fontWeight: 'bold',
              fontSize: '18px',
            }}
          >{t('update_cvv')}</Typography>
          <Typography
            sx={{
              fontWeight: 'bold',
              fontSize: '12px',
              color: theme.palette.text.tertiary
            }}
          >{t('update_cvv_desc')}</Typography>
        </Box>
        <Box direction="column" className={classes.card}>
          <Box className={classes.cardDetail}
            sx={theme => {
              return {
                overflow: 'visible',
                // width: theme.typography.pxToRem(343), //'343px',
                height: 201 * cardScale + 'px', //theme.typography.pxToRem(), // '201px',
                maxHeight: 201 * (520 / 375) + 'px'
              }
            }}
          >
            <RedotpayCard cardItem={getCardDetailReq?.data} convert={true} />
          </Box>
        </Box>
        <Box
          sx={{
            ...styles
          }}
        >
          <Stack
            sx={{
              ...styles,
              height: '64px',
              backgroundColor: theme.palette.background.card
            }}
            direction="row" justifyContent="space-between" alignItems="center">
            <Typography>{t('reissue_fee')}</Typography>
            {getCardReissueTypesReq?.data && <Typography
              sx={{ color: theme.palette.brand.main }}
            >{reissueInfo?.price <= 0 ? t('first_time_free') : `${t('pay')} ${(reissueInfo <= -1 ? '' : reissueInfo?.price)} USD`}</Typography>}
          </Stack>
        </Box>
        <Box
          sx={{
            position: 'absolute',
            width: '100%',
            padding: '0 16px',
            bottom: '16px'
          }}
        >
          <LoadingButton
            size="large"
            variant="contained"
            fullWidth
            sx={{
              borderRadius:"24px"
            }}
            loading={reissuePreviewReq.loading || applyReissueReq.loading}
            onClick={() => {
              previewModalOpenOperate.setTrue()
              // reissuePreviewReq.runAsync().then((res) => {
              //   applyReissueReq.runAsync().then(() => {
              //     dispatch(getCardList());
              //     enqueueSnackbar(t('success'), { variant: 'success' })
              //     dispatch(getUserInfo());
              //     dispatch(getCardList());
              //     dispatch(getCardAvailable());
              //     navigate(`${RouteConstant.SUCCESS}?source=reissue_card`)
              //     // navigate(RouteConstant.MAIN)
              //   })
              // }).catch((err) => {
              //   console.log('err', err)
              //   if (err.message.indexOf('7031') > -1) {
              //     reisssuePreviewModalOpenOperate.setTrue()
              //   }
              //   // enqueueSnackbar(err.message, { variant: 'error' })
              // })
            }}
          >
            {`${t('pay')} ${reissueInfo <= -1 ? '' : reissueInfo.price} USD`}
          </LoadingButton>
        </Box>
      </Stack>
      <AppModal open={reissssuePreviewInfoModalOpen} onClose={reisssuePreviewModalOpenOperate.setFalse}>
        <Stack>
          <SimpleHeader
            sx={{
              borderTopLeftRadius: '8px',
              borderTopRightRadius: '8px',
            }}
            backEnable
            title={t('pay')}
            closeButton={<RpIcon icon="close" size={14} clickable onClick={() => {
              reisssuePreviewModalOpenOperate.setFalse()
            }} />}
          />
          <Stack sx={{ padding: '0 16px', paddingBottom: '16px' }}>
            <Stack
              direction="row" alignItems="center" justifyContent="center">
              <span style={{ fontSize: '16px', fontWeight: 'bold' }}>$</span>
              <Typography
                sx={{
                  fontWeight: 'bold',
                  padding: '16px 0',
                  color: theme.palette.text.primary,
                  fontSize: '32px',
                  textAlign: 'center'
                }}
              >{reissueInfo?.price}</Typography>
            </Stack>
            <Typography
              sx={{ color: theme.palette.brand.main }}
              textAlign="center">{t('please_deposit')}</Typography>
            <LoadingButton onClick={() => {
              reisssuePreviewModalOpenOperate.setFalse()
              varietySelectModalOpenOperate.setTrue()
            }} sx={{ marginTop: '16px',borderRadius:"20px"}} fullWidth variant="contained">
              {t('deposit')}
            </LoadingButton>
          </Stack>
        </Stack>

      </AppModal>
      <VarietySelectModal open={varietySelectModalOpen}
        varietyOperate={'deposit'}
        onClose={varietySelectModalOpenOperate.setFalse}
        onSelected={onVarietySelected}
      />
      <AppModal open={previewModalOpen} onClose={previewModalOpenOperate.setFalse}>
        <Stack>
          <SimpleHeader
            sx={{
              borderTopLeftRadius: '8px',
              borderTopRightRadius: '8px',
            }}
            backEnable
            title={t('pay')}
            closeButton={<RpIcon icon="close" size={14} clickable onClick={() => {
              previewModalOpenOperate.setFalse()
            }} />}
          />
          <Stack sx={{ padding: '0 16px', paddingBottom: '16px' }}>
            <Stack
              direction="row" alignItems="center" justifyContent="center">
              <span style={{ fontSize: '16px', fontWeight: 'bold' }}>$</span>
              {getCardReissueTypesReq?.data && <Typography
                sx={{
                  fontWeight: 'bold',
                  padding: '16px 0',
                  color: theme.palette.text.primary,
                  fontSize: '32px',
                  textAlign: 'center'
                }}
              >
                {reissueInfo?.price <= 0 ? "0.00" : `${(reissueInfo <= -1 ? '' : reissueInfo?.price)}`}
                </Typography>
              }
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent="space-between"
              sx={{
                backgroundColor: theme.palette.background.card,
                padding: '16px',
                borderRadius: '8px'
              }}
            >
              <Stack direction="row" alignItems="center" gap="16px">
                <img src="/images/coin/usdt.svg" style={{ width: 24, height: 24 }} />
                <Stack>
                  <Typography>USDT</Typography>
                  <Typography>{t('available')} {homeInfo?.assetUser?.available}</Typography>
                </Stack>
              </Stack>
              <Typography>
                {
                  reissueInfo?.price <= 0?"0.00":"-5.00"
                }
              </Typography>
            </Stack>
            <LoadingButton
              loading={applyReissueReq.loading}
              onClick={() => {
                reissuePreviewReq.runAsync().then((res) => {
                  applyReissueReq.runAsync().then(() => {
                    dispatch(getCardList());
                    enqueueSnackbar(t('success'), { variant: 'success' })
                    dispatch(getUserInfo());
                    dispatch(getCardList());
                    dispatch(getCardAvailable());
                    navigate(`${RouteConstant.SUCCESS}?source=reissue_card`)
                    // navigate(RouteConstant.MAIN)
                  })
                }).catch((err) => {
                  previewModalOpenOperate.setFalse()
                  reisssuePreviewModalOpenOperate.setTrue()
                  if (err.message.indexOf('7031') > -1) {
                    reisssuePreviewModalOpenOperate.setTrue()
                  }
                  // enqueueSnackbar(err.message, { variant: 'error' })
                })

              }} sx={{ marginTop: '16px',borderRadius:"20px" }} fullWidth variant="contained">
              {t('confirm')}
            </LoadingButton>
          </Stack>
        </Stack>

      </AppModal>
    </>

  );
}

export default ReissueCard;